import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { Venues } from '@weddingspot/ws-api-client';
// import ReactPlayer from 'react-player';
const ReactPlayer = dynamic(() => import('react-player/lazy'));

import styles from '../gallery.module.scss';

interface GalleryVideoProps {
    videos: Venues.VenueVideo[];
    index: number;
}

const GalleryVideo = ({ videos, index }: GalleryVideoProps) => {
    const [playing, setPlaying] = useState(false);
    return (
        <div className={styles.videoWrapper}>
            {!playing && (
                <div
                    className={styles.videoWrapperSwappable}
                    onClick={() => {
                        setPlaying(!playing);
                    }}
                />
            )}
            <ReactPlayer url={videos[index].embedded_video} width={'100%'} muted={true} controls={true} playing={playing} />
        </div>
    );
};

export default GalleryVideo;
